const mapToIdentity = require('./mapToIdentity');
const mapFromIdentity = require('./mapFromIdentity');
const validateIdentity = require('./validateIdentity');

module.exports = {
  mapToIdentity,
  mapFromIdentity,
  validateIdentity,
};
